import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiStepLabel: {
      styleOverrides: {
        root: {
          padding: "3px 0",
        },
        label: {
          fontFamily: "inherit",
          fontSize: "15px",
          fontWeight: "600 !important",
          color: "#333333",
        },
        iconContainer: {
          marginLeft: "0.125rem",
          position: "relative",
        },
      },
    },
    MuiStepContent: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: (props) => props.last,
              style: {
                borderLeftColor: "transparent",
              },
            },
          ],
          borderLeftStyle: "dashed",
          borderLeftColor: "#BEC3C7",
          borderLeftWidth: "1px",
          fontFamily: "inherit",
          paddingTop: "12px",
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          width: "1.25rem",
          height: "1.25rem",
          color: "#ccc",
          variants: [
            {
              props: ({ active, completed }) => active || completed,
              style: {
                color: "#F69133 !important",
                height: "1.25rem",
                width: "1.25rem",
              },
            },
            {
              props: ({ active }) => active,
              style: {
                borderRadius: "50%",
                transition: "box-shadow 0.3s",
                boxShadow: "0 0 0 3px rgba(246, 145, 51, 0.2)",
              },
            },
          ],
        },
        text: {
          fontWeight: "700",
          fontFamily: "inherit",
          fill: "#333",
          opacity: "0.5",
          variants: [
            {
              props: ({ active, completed }) => active || completed,
              style: {
                fill: "white !important",
                opacity: 1,
              },
            },
          ],
        },
      },
    },
    MuiStepConnector: {
      styleOverrides: {
        line: {
          borderLeftStyle: "dashed",
          borderLeftColor: "#BEC3C7",
          marginTop: "2px",
          minHeight: "38px",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          fontFamily: "inherit",
          fontSize: "14px",
          background: "rgba(255, 255, 255, 0.2)",
          color: "#333333",
          variants: [
            {
              props: (props) => props.value === "",
              style: {
                color: "rgba(130, 130, 130, 0.6)",
              },
            },
          ],
        },
      },
    },
  },
});

const stepper = theme.components;

export default stepper;
